import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import AbEnvironment from './auth/AbEnvironment';
import { Grid, Typography } from '@mui/material';

import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';

const smallDeviceSize = 668;
const abEnvironment = new AbEnvironment();

//Query fetches the customers parent for reseller name and logo
const AppBarCustLandingLogoQuery = graphql`
query AppBarCustLandingLogoQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
     accountTByParentId {
      accountName
      logo
    }
  }
}
`;

const styleSheet = theme => ({
  managedByLabel: {
    color: theme.palette.secondary.main,
  },
  managedByAccountLabel: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
  },
  titleContainerOpen: {
    position: 'absolute',
    left: '208px',
    top: '14px'
  },  
  titleContainerClosed: {
    position: 'absolute',
    left: '64px',
    top: '14px'
  }
});

class AppBarCustLandingLogo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      smallDevice: (window.innerWidth < smallDeviceSize)
    };
 
    // .bind() creates a NEW instance of the target function
    // store this instance in a variable and use in componentDidMount() and componentWillUnmount()
    this.onResizeBound = this.onResize.bind(this);
    // if you code it this way:
    //  window.addEventListener('resize', this._onResize.bind(this));
    //  window.removeEventListener('resize', this._onResize.bind(this));
    // this is wrong! as mentioned above .bind() creates a NEW instance of the target function
    // therefore the removeEventListener() is not removing the original reference on the addEventListener()
    // and the event and handler function is executing on other pages
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResizeBound);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResizeBound);
  }

  onResize() {
    //console.log( 'small=' + this.state.smallDevice + ', width=' + window.innerWidth );
    if( this.state.smallDevice && window.innerWidth >= smallDeviceSize ) {
      this.setState({smallDevice: false});

    } else if ( !this.state.smallDevice && window.innerWidth < smallDeviceSize ) {
      this.setState({smallDevice: true});
    }
  }

  render() {
    const classes = this.props.classes;

    let acctId = this.props.auth.getAccountUUID();
    let menuOpen = this.props.menuOpen;
    // let customerAccountName = abEnvironment.getUserAttribute("a_accountName");

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={AppBarCustLandingLogoQuery}
        variables={{accountId: acctId}}
        render={({error, props})=> {
          if (error) {
            return;
          } else if (props) {
            //if shape is what we expect, show the app par title under variety of viewports and menu open / closed.
            if (props.accountTByAccountId && props.accountTByAccountId.accountTByParentId && props.accountTByAccountId.accountTByParentId.accountName) {
              let theTitle = 'Managed by ' + props.accountTByAccountId.accountTByParentId.accountName;
              if (this.props.isMasquerade === true) {
                theTitle = theTitle + ' (masquerade)';
              }
              if (menuOpen) {
                if (! this.state.smallDevice) {
                  return (
                    <div className={classes.titleContainerOpen}>
                      <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0.5}>
                        <Grid item><Typography variant="body1" className={classes.managedByLabel}>Managed by</Typography></Grid>
                        <Grid item><Typography variant="body1" className={classes.managedByAccountLabel}>{props.accountTByAccountId.accountTByParentId.accountName}</Typography></Grid>
                        {this.props.isMasquerade === true &&
                        <Grid item><Typography variant="body1" className={classes.managedByLabel}>(masquerade)</Typography></Grid>}
                      </Grid>
                    </div>
                  );                
                } else {
                  return null;
                }
              } else {
                return (
                  <div className={classes.titleContainerClosed}>
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0.5}>
                      <Grid item><Typography variant="body1" className={classes.managedByLabel}>Managed by</Typography></Grid>
                      <Grid item><Typography variant="body1" className={classes.managedByAccountLabel}>{props.accountTByAccountId.accountTByParentId.accountName}</Typography></Grid>
                      {this.props.isMasquerade === true &&
                      <Grid item><Typography variant="body1" className={classes.managedByLabel}>(masquerade)</Typography></Grid>}
                    </Grid>
                  </div>
                );
              }
            }
          }
        }}
          //NOTE: did not add spinner has it ended up having two on the page. 
      />
    );
  }
}


export default withStyles(styleSheet)(AppBarCustLandingLogo);


/*
                  let useGrid = true;
                  if (useGrid === false) {
                    return (
                      <div className={classes.titleContainerClosed}>
                        <Typography style={{color: 'black'}} variant="subtitle1">{theTitle}</Typography>
                      </div>
                    );
                  }

                  return (
                    <div className={classes.titleContainerClosed}>
                      <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
                        <Grid item><Typography variant="body2">Managed by ggg</Typography></Grid>
                        <Grid item><Typography variant="body2">{props.accountTByAccountId.accountTByParentId.accountName}</Typography></Grid>
                        {this.props.isMasquerade === true &&
                        <Grid item><Typography variant="body2">(masquerade)</Typography></Grid>}
                      </Grid>
                    </div>
                  );

*/
